<script>
export default {
  data: function () {
    return { 
      content: null,
      containerContent: null
    };
  },
  computed: {
    componentReady() {
      return this.content && this.content.layout && this.containerContent;
    }
  },
  mounted() {
    Fandom.onEvent('show-fullscreen-modal', (data) => {
      this.content = data.content;
      this.containerContent = data.containerContent;

      this.show();
    });
  },
  methods: {
    show() {
      $(this.$refs['fullscreen-modal']).modal('show');
    }
  }
};
</script>

<template>
  <div ref="fullscreen-modal" class="modal fade" tabindex="-1" data-backdrop="false">
    <div class="modal-dialog d-flex w-100 mw-100 h-100 m-0">
      <div class="modal-content rounded-0 overflow-auto">
        <div class="modal-header border-0 pb-0">
          <button type="button" class="close cursor-pointer" data-dismiss="modal" aria-label="Close">
            <i class="fal fa-times" aria-hidden="true"></i>
          </button>
        </div>
        <div class="modal-body d-flex align-items-center pb-5">
          <div class="w-100">
            <component
              v-if="componentReady"
              :is="content.layout"
              :content="content"
              :optContainerContent="containerContent"
            ></component>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
  .icon {
    width: 3rem;
    height: auto;
  }
</style>